module.exports = __webpack_public_path__ + "img/envelope-4.b73519ca.svg";